interface Props {
  sidebar?: React.ReactNode
  content: React.ReactNode
  toolbar: React.ReactNode
}

export function CollectionPage({ sidebar, content, toolbar }: Props) {
  return (
    <div className="flex flex-1 md:px-4">
      {sidebar}
      <div className="flex flex-1 flex-col gap-4">
        <div className="flex flex-1 flex-col md:px-4">{content}</div>
        {toolbar}
      </div>
    </div>
  )
}
